import { mergeMap, type Observable, of } from 'rxjs';
import type { PageSettings, PageSettingsUpdateRequest } from '@common/types/page-settings.type';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import * as PageSettingsSelectors from './page-settings.selectors';
import PageSettingsActions from './page-settings.actions';

@Injectable()
export class PageSettingsFacade {
    private readonly store = inject(Store);

    public pageSettings$(siteId: number | string, pageId: number | string): Observable<PageSettings> {
        return this.store.select(PageSettingsSelectors.selectPageSettings(pageId)).pipe(
            mergeMap((pageSettings) => {
                if (pageSettings === null) {
                    this.loadPageSettings(siteId, pageId);
                    return of(null);
                }

                return of(pageSettings);
            })
        );
    }

    public loadPageSettings(siteId: number | string, pageId: number | string): void {
        this.store.dispatch(
            PageSettingsActions.loadPageSettingsRequest({ siteId: siteId.toString(), pageId: pageId.toString() })
        );
    }

    public updatePageSettings(siteId: number, pageId: number, settings: PageSettingsUpdateRequest): void {
        this.store.dispatch(PageSettingsActions.updatePageSettingsRequest({ siteId, pageId, settings }));
    }
}
